/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalSubmissionPresetCounts } from './PalSubmissionPresetCounts';
import {
    PalSubmissionPresetCountsFromJSON,
    PalSubmissionPresetCountsFromJSONTyped,
    PalSubmissionPresetCountsToJSON,
} from './PalSubmissionPresetCounts';

/**
 * 
 * @export
 * @interface FindPalSubmissionPresetCounts200Response
 */
export interface FindPalSubmissionPresetCounts200Response {
    /**
     * 
     * @type {PalSubmissionPresetCounts}
     * @memberof FindPalSubmissionPresetCounts200Response
     */
    data?: PalSubmissionPresetCounts;
}

/**
 * Check if a given object implements the FindPalSubmissionPresetCounts200Response interface.
 */
export function instanceOfFindPalSubmissionPresetCounts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindPalSubmissionPresetCounts200ResponseFromJSON(json: any): FindPalSubmissionPresetCounts200Response {
    return FindPalSubmissionPresetCounts200ResponseFromJSONTyped(json, false);
}

export function FindPalSubmissionPresetCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindPalSubmissionPresetCounts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalSubmissionPresetCountsFromJSON(json['data']),
    };
}

export function FindPalSubmissionPresetCounts200ResponseToJSON(value?: FindPalSubmissionPresetCounts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalSubmissionPresetCountsToJSON(value.data),
    };
}

